/**
 * 共通アンカースクロール
 */
import AnyStore from './AnyStore';

/**
 * 初回アクセス時の青いローデイング
 */
export default class AnchorScroll {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'AnchorScroll';
    this.margin = 100;

    this.init();
  }

  /**
   * 初期化
   */
  init() {
    document.querySelectorAll('.js-anchor').forEach((el, index) => {
      el.addEventListener('click', this.onAnchor.bind(this,[el, index]));
    });
  }

  /**
   * アンカーをクリック
   */
  onAnchor(opt, e) {
    const offset = AnyStore.getOffsetTop(document.getElementById(opt[0].getAttribute('data-anchor')));
    TweenMax.to(window, 0.4, {scrollTo:{y: offset.top - this.margin, autoKill: false}, ease: Cubic.easeOut});
  }

  /**
   * スクロール開始
   */
  start() {
    const elID = location.hash.replace('#', '');
    if (!elID) return;

    const el = document.getElementById(elID);
    if (!el) return;

    const o = AnyStore.getOffsetTop(el);

    TweenMax.to(window, 0.4, {scrollTo:{y: o.top - this.margin, autoKill: false}, ease: Cubic.easeOut});
  }
}
